import commonTheme from './commonTheme';

const defaultTheme = {
  defaultTheme: {
    ...commonTheme
  }
}

export default defaultTheme;